import { render, staticRenderFns } from "./Hrga.vue?vue&type=template&id=12a8a215"
import script from "./Hrga.vue?vue&type=script&lang=js"
export * from "./Hrga.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports